export default __webpack_public_path__ + "static/media/main2_s.743212b0.jpg";